import { CourseMarkdown } from "@/components/storyboard/CourseMarkdown";

export interface QuizChallengeHeadingProps {
  challenge?: string;
}

/**
 * The task statement at the top of a code quiz's left pane.
 */
export const QuizChallengeHeading = ({
  challenge,
}: QuizChallengeHeadingProps) => {
  if (!challenge) return null;

  return (
    <div className="prose quiz-question max-w-full text-primary font-semibold">
      <CourseMarkdown>{challenge}</CourseMarkdown>
    </div>
  );
};
